import { Formik } from 'formik';
import { Modal } from '@shared/components/modals/Modal';
import { workflowFormValidationSchema } from '../../constants';
import { EnitityType, TWorkflowFormState, TWorkflowModalProps } from '../../types';
import { WorkflowForm } from './WorkflowForm';

export const WorkflowModal = ({ handleClose, handleSubmit, isEditMode, currentWorkflow, workflowModalPosition }: TWorkflowModalProps) => {
  const initialWorkflowFormState: TWorkflowFormState = {
    name: (isEditMode && currentWorkflow?.workflowName) || '',
    entityType: (isEditMode && currentWorkflow?.entityType as EnitityType) || 'Lead',
  };

  return (
    <Modal 
      open
      hideBackdrop
      resetPosition={workflowModalPosition}
      title={!isEditMode ? 'Add New Workflow' : 'Edit Workflow Name'}
      dialogWidth="25vw" 
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        initialValues={initialWorkflowFormState as TWorkflowFormState}
        validationSchema={workflowFormValidationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => <WorkflowForm {...props} handleClose={handleClose} isEditMode={isEditMode} />}
      </Formik>
    </Modal>
  );
};
